import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

// Shared derivation of the renewal display state consumed by the
// dashboard and the top-ups page. All three fields reset together when
// no valid subscription exists, so a cleared source can never leave a
// stale Renewal Date rendered beside an N/A Plan Length (review finding
// EA1). The "year" fallback only applies when a subscription exists
// without a renews_after value (pushback decision 3 parity).
export const deriveRenewalDisplay = (subscriptionData) => {
    const expiry = subscriptionData?.expires;
    if (!expiry || !dayjs(expiry).isValid()) {
        return { renewDate: "", renewWhen: "", period: "" };
    }
    return {
        renewDate: dayjs(expiry).format("DD/MM/YYYY"),
        renewWhen: dayjs().to(dayjs(expiry), true),
        period: subscriptionData.renews_after || "year",
    };
};
